@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.fieldset {
  padding: 0;
  position: relative;
  border: none;
  margin: 0 0 24px;
  margin-top: 15px;
  font-family: typography.$font-mont;

  @include breakpoints.desktop {
    margin-top: 15px;
  }
}

.legend {
  margin-bottom: 8px;
  display: inherit;
  color: var(--brand-indigo);
  font-family: typography.$font-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;


  @include breakpoints.desktop {
    top: 4px;
    width: 180px;
    margin: 0;
  }
}

.alwaysVertical {
  @include breakpoints.desktop {
    position: static;
    text-align: left;
    margin-left: 212px;
    margin-right: 124px;
    width: inherit;
  }
}

.aside {
  font-weight: var(--regular-weight);
  display: block;
  margin-top: 15px;
  color: var(--brand-indigo);
  font-family: typography.$font-mont;
  font-size: 12px;
}

.fieldGroup {
  @include breakpoints.desktop {
    margin: 0 124px 48px 212px;
    margin-left: 0;
  }
}